import { Component, EventEmitter, Input, OnInit, Optional, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Subscription } from 'rxjs';
import { ModalObjectType } from 'src/app/interfaces/modal-object-types.interface';
import { CashReceiptModel } from 'src/app/models/wallet/cash-receipt.model';
import { CashReceiptsPrintModel } from 'src/app/models/wallet/cash-receipts-print.model';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

@Component({
  selector: 'app-cash-receipt-printing-range',
  templateUrl: './cash-receipt-printing-range.component.html',
  styleUrls: ['./cash-receipt-printing-range.component.scss'],
  standalone: false
})
export class CashReceiptPrintingRangeComponent implements OnInit {

  @Input() cashReceiptModel: CashReceiptModel = new CashReceiptModel();
  @Output() emitCashReceiptModel = new EventEmitter<Array<CashReceiptsPrintModel>>();

  consecutiveCashReceipt: number = 0;
  consecutiveInitial: number = 0;
  consecutiveFinal: number = 0;
  formPrintingRange: FormGroup = new FormGroup({});
  suscription: Subscription;

  constructor(public config: DynamicDialogConfig,
    private formBuilder: FormBuilder,
    private toastHandlerService: ToastHandlerService,
    @Optional() private ref: DynamicDialogRef) {
    this.validateForm();
  }

  ngOnInit() {
    const input$ = this.config.data?.inputs$;
    if (!input$) {
      console.error('inputs$ no está definido en config.data');
      return;
    }
    this.suscription = input$?.subscribe((inputs: any) => {
      this.consecutiveCashReceipt = inputs.consecutiveCashReceipt;
      this.formPrintingRange.controls["consecutiveInitial"].setValue(this.consecutiveCashReceipt);
      this.formPrintingRange.controls["consecutiveFinal"].setValue(this.consecutiveCashReceipt);
    });
  }

  close(printCashReceipt: boolean = false) {
    const data: ModalObjectType = {};
    if (printCashReceipt) {
      if (this.formPrintingRange.invalid) {
        this.toastHandlerService.showToast('warning', 'Los consecutivos deben ser mayores a 0');
        return;
      }
      this.toastHandlerService.clearAllToasts();
      data.params = {
        printCashReceipt: true,
        consecutiveInitial: this.formPrintingRange.get("consecutiveInitial")?.value,
        consecutiveFinal: this.formPrintingRange.get("consecutiveFinal")?.value
      };
      this.ref.close(data);
    } else {
      data.params = {
        printCashReceipt: false,
        consecutiveInitial: 0,
        consecutiveFinal: 0
      };
      this.ref.close(data);
    }
  }

  validateForm() {
    this.formPrintingRange = this.formBuilder.group({
      consecutiveInitial: [0, [Validators.min(1)]],
      consecutiveFinal: [0, [Validators.min(1)]]
    });
  }

}
